'use client'

import { Text } from '@vinted/web-ui'

import { FormattedMessage } from '@marketplace-web/i18n/i18n-feature'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'

export const MAX_ITEM_COUNT = 500

const ItemCount = () => {
  const {
    state: {
      items: { pagination, error },
    },
  } = useCatalogContext()

  if (!pagination?.total_entries) return null
  if (error) return null

  const totalEntries = pagination.total_entries

  const count = totalEntries > MAX_ITEM_COUNT ? `${MAX_ITEM_COUNT}+` : totalEntries

  return (
    <Text
      type={Text.Type.Subtitle}
      text={
        <FormattedMessage
          id="catalog.item_count"
          pluralize
          count={totalEntries}
          values={{ count }}
        />
      }
      as="span"
    />
  )
}

export default ItemCount
